import { render, staticRenderFns } from "./ProductSpecimenList.vue?vue&type=template&id=5d8ac562&scoped=true"
import script from "./ProductSpecimenList.vue?vue&type=script&lang=js"
export * from "./ProductSpecimenList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8ac562",
  null
  
)

export default component.exports